import { FormattedMessage, useIntl } from 'react-intl';
import styled from 'styled-components';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { DisplayS, LabelM } from '@sorare/core/src/atoms/typography';
import { useCurrentUserContext } from '@sorare/core/src/contexts/currentUser';
import { glossary, rivals } from '@sorare/core/src/lib/glossary';

import { GridBackground } from '@sorare/gameplay/src/components/rivals/GridBackground';
import { BackgroundAligned } from '@sorare/gameplay/src/components/rivals/GridBackground/BackgroundAligned';

import { PodiumAvatar } from 'components/rivals/seasons/SeasonLeaderboard/SeasonLeaderboardHeader/PodiumAvatar';
import { ContentUnitLayout } from 'components/rivals/seasons/WelcomeToTheArena/ContentUnitLayout';
import { Description } from 'components/rivals/seasons/WelcomeToTheArena/Description';
import fourStarsBox from 'components/rivals/seasons/WelcomeToTheArena/assets/four-stars-box.png';
import jersey from 'components/rivals/seasons/WelcomeToTheArena/assets/jersey.png';
import mbappeLimited from 'components/rivals/seasons/WelcomeToTheArena/assets/mbappe-limited.png';

const PodiumAvatarWrapper = styled.div`
  transform: scale(1.5);
`;
const Reward = styled.img`
  height: calc(10 * var(--unit));
  filter: drop-shadow(0 0 var(--double-unit) var(--c-neutral-500));
`;
const Jersey = styled(Reward)`
  transform: rotate(12deg);
`;
const Card = styled(Reward)`
  transform: rotate(-6deg);
`;
const RewardBox = styled.img`
  width: calc(6 * var(--unit));
`;
const RewardLabel = styled(LabelM).attrs({
  bold: true,
})`
  text-transform: uppercase;
`;

export const WinRewards = () => {
  const { currentUser } = useCurrentUserContext();
  const { formatMessage } = useIntl();

  return (
    <GridBackground
      height="100%"
      bgColor="var(--c-neutral-200)"
      color="#33CE78"
      customGradient="linear-gradient(to bottom, rgba(var(--c-rgb-neutral-100), 0.54) 0%, rgba(var(--c-rgb-neutral-100), 0.54) 100%), linear-gradient(to bottom, rgba(var(--c-rgb-score-high), 0.9) 0%, transparent 100%)"
    >
      <ContentUnitLayout>
        <DisplayS>
          <FormattedMessage
            id="WelcomeToTheArena.WinRewards.title"
            defaultMessage="Win Rewards"
          />
        </DisplayS>
        <Description>
          <FormattedMessage
            id="WelcomeToTheArena.WinRewards.description2"
            defaultMessage="Get amazing rewards every week!"
          />
        </Description>
      </ContentUnitLayout>
      <BackgroundAligned horizontalDelta={0} verticalDelta={-0.75}>
        {currentUser && (
          <PodiumAvatarWrapper>
            <PodiumAvatar
              rank={1}
              user={currentUser}
              width={100}
              nickname={formatMessage(glossary.you)}
            />
          </PodiumAvatarWrapper>
        )}
      </BackgroundAligned>
      <BackgroundAligned horizontalDelta={1.5} verticalDelta={1.5}>
        <Jersey src={jersey} alt="" />
      </BackgroundAligned>
      <BackgroundAligned horizontalDelta={-1.5} verticalDelta={1.5}>
        <Card src={mbappeLimited} alt="" />
      </BackgroundAligned>
      <BackgroundAligned horizontalDelta={0} verticalDelta={1.25}>
        <Vertical gap={1.5} center>
          <RewardLabel color="var(--c-neutral-600)">
            <FormattedMessage {...rivals.rewardLabel} />
          </RewardLabel>
          <RewardBox src={fourStarsBox} alt="" />
        </Vertical>
      </BackgroundAligned>
    </GridBackground>
  );
};
